// test1475
(1475 && 0);
